// Core
import { useState } from "react";
import { useTranslations } from "next-intl";

// Definitions
import { ErrorResponse, IRecoveryPasswordFieldFetch, UseAuthRecoveryType } from "../types";

// Utils
import { recoveryPassword } from "@/domains/auth/actions";

export const useAuthRecovery = (): UseAuthRecoveryType => {
  const [error, setError] = useState<ErrorResponse["violations"]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const tValidation = useTranslations("Validation");

  const onMutateAuth = async (mutatePayload: IRecoveryPasswordFieldFetch) => {
    setLoading(true);
    setError([]);

    const formData = new FormData();
    formData.append("login", mutatePayload.login);
    formData.append("type", mutatePayload.type);
    formData.append("countryCode", mutatePayload.countryCode);

    const res = await recoveryPassword(formData);

    if (res?.errors) {
      setError(res.errors);
    }

    setLoading(false);

    return res;
  };
  const renderErrorMessage = (
    propertyName: string,
    authError: ErrorResponse["violations"],
  ): string | null => {
    const foundError = authError?.find((_error) => _error.property === propertyName);
    return foundError ? tValidation(foundError.error) : null;
  };

  return {
    error,
    onMutateAuth,
    loading,
    renderErrorMessage,
  };
};
